import { render, staticRenderFns } from "./restoreCompanies.vue?vue&type=template&id=ec1b5892&scoped=true"
import script from "./restoreCompanies.vue?vue&type=script&lang=js"
export * from "./restoreCompanies.vue?vue&type=script&lang=js"
import style0 from "./restoreCompanies.vue?vue&type=style&index=0&id=ec1b5892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1b5892",
  null
  
)

export default component.exports